import React from 'react';
import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import './styles/FinalizarPago.css';


const PagoExitoso = () => {
    const { compraId } = useParams();
    const [estado, setEstado] = useState('cargando');
    const [error, setError] = useState(null);
    const [productosComprados, setProductosComprados] = useState([]);
    const [devueltos, setDevueltos] = useState([]); // Array de ids de productos devueltos 
    const [sesionesPorClase, setSesionesPorClase] = useState({}); //Mostrar las sesiones

    let baseUrl;
    if(process.env.NODE_ENV === 'development') baseUrl = 'http://localhost:8080';
    else baseUrl='https://app-formacion.vercel.app';

    useEffect(() => {
        const comprayproductos = async () => {
            try{
                const res = await fetch(`${baseUrl}/api/compras/${compraId}`)
                if(!res.ok) throw new Error('No se encontró la compra');
                const compraData = await res.json();

                const devueltos = (compraData.ProductosDevueltos || []).map((id) =>
                    id.toString()
                );
                setDevueltos(devueltos);

                const listaIds = compraData.Id_Contenido;
                
                const productosPromises = listaIds.map(async (id) => {
                    let contRes = await fetch(`${baseUrl}/api/clases/${id}`);
                    if(contRes.ok) {
                        //Si lo encuentra en clase:
                        const cont = await contRes.json();
                        return {...cont, tipo: 'clase'};
                    }
                    //Si no está en clase es un curso
                    contRes = await fetch(`${baseUrl}/api/cursos/${id}`);
                    if (contRes.ok) {
                        const cont = await contRes.json();
                        return { ...cont, tipo: 'curso' };
                    }

                    // Si ninguno existe, devolvemos tipo 'desconocido'
                    return { _id: id, Nombre: 'Contenido no encontrado', tipo: 'desconocido' };
                });
                const detalles = await Promise.all(productosPromises);
                setProductosComprados(detalles);

                //Cargar las sesiones para las clases no devueltas
                const clasesSesiones = detalles.filter(
                    item => item.tipo === 'clase' && !devueltos.includes(item._id.toString())
                )

                const sesionesPorClaseTemp = {};

                await Promise.all(clasesSesiones.map(async cl => {
                    if(!cl.Id_Sesion || cl.Id_Sesion.length === 0) return;
                    
                    const idsQuery = cl.Id_Sesion.join(",");
                    const resSesiones = await fetch(`${baseUrl}/api/sesiones/search/clase/${idsQuery}`);
                    if (resSesiones.ok) {
                        const sesiones = await resSesiones.json();
                        sesiones.sort((a, b) => a.Parte - b.Parte); // Ordenar por Parte
                        sesionesPorClaseTemp[cl._id] = sesiones;
                    }
                }));
            
                setSesionesPorClase(sesionesPorClaseTemp);

                setEstado('completado');
            } catch(error){
                console.error(error);
                setError(error.message);
                setEstado('error');
            }
        };
        comprayproductos();
    }, [compraId]);


if (estado === 'cargando') {
    return (
        <div className='principalPagoEx'>
            <p className="mensajeCargando">Cargando detalles de la compra…</p>;
        </div>
    )
}

if (estado === 'error') {
    return (
        <div className='principalPagoEx'>
            <div className="mensajeError">
                <h2>No se encontró la compra</h2>
                <p>{error}</p>
                <Link to="/" className="successLink">Volver al inicio</Link>
            </div>
        </div>
    );
}

return (
    <div className='principalPagoEx'>
        <div className="pagoOK">
            <h2>¡Gracias por tu compra!</h2>
            <p>Enlaces de descarga o acceso a clases (puede acceder aquí siempre que quiera a tavés de la URL o en la sección "Mis Compras"):</p>
            <ul className="listaDescargas">
                {productosComprados.map(item => {
                    let esDevuelto = devueltos.includes(item._id.toString());

                    if (item.tipo === 'curso') {
                        if (esDevuelto) {
                            return (
                                <li key={item._id}>
                                    <span className="textoDevuelto">
                                        Has devuelto este curso: {item.Nombre}
                                    </span>
                                </li>
                            );
                        }

                        const urlDescarga = `${baseUrl}/api/cursos/descargar/${item._id}?usuarioId=${JSON.parse(localStorage.getItem('userLogueado'))._id}`;
                        return (
                            <li key={item._id}>
                                {item.Nombre === null && item.Descripcion === null && item.FechaSubida === null && item.Tematica === null && item.ImagenPortada === null ? (
                                    <a className="enlaceDescargar" href={urlDescarga} target="_blank" rel="noopener noreferrer">
                                        Este curso ha sido eliminado, pero puedes acceder a él cuando desees.
                                    </a>
                                ) : (
                                    <a className="enlaceDescargar" href={urlDescarga} target="_blank" rel="noopener noreferrer">
                                        Descargar curso {item.Nombre}
                                    </a>
                                )}
                            </li>
                        );
                    } else {
                        if (esDevuelto) {
                            return (
                                <li key={item._id}>
                                    <span className="textoDevuelto">
                                        Has devuelto esta clase: {item.Nombre}
                                    </span>
                                </li>
                            );
                        }
                        return (
                            <li key={item._id}>
                                <Link to={`/detalleContenido/${item._id}`} className="enlaceClase">Clase {item.Nombre}</Link>

                                {sesionesPorClase[item._id] && (
                                    <ul className='listaSesiones'>
                                        {sesionesPorClase[item._id].map(sesion => {
                                            const fechaSesion = new Date(sesion.Fecha);
                                            const ahora = new Date();
                                           /* const mismaFecha = ahora.getFullYear() === fechaSesion.getFullYear() &&
                                                               ahora.getMonth() === fechaSesion.getMonth() &&
                                                               ahora.getDate() === fechaSesion.getDate();*/
                                            const horaApertura = new Date(fechaSesion.getTime() - 60 * 60 * 1000);
                                            const horaCierre = new Date(fechaSesion.getTime() + 24 * 60 * 60 * 1000);

                                            const habilitado = ahora >= horaApertura && ahora < horaCierre;
                                            
                                            const fechaStr = fechaSesion.toLocaleDateString();
                                            const horaStr = fechaSesion.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

                                             return (
                                                <li key={sesion._id} className="itemSesion">
                                                    <strong>Parte {sesion.Parte}</strong> — {sesion.Nombre}<br />
                                                    Fecha: {fechaStr}<br />
                                                    Hora: {horaStr}<br />
                                                    <a
                                                        href={sesion.Enlace}
                                                        className={`enlaceSesion ${!habilitado ? 'deshabilitado' : ''}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        onClick={(e) => { if (!habilitado) e.preventDefault(); }}
                                                    >
                                                        {habilitado ? ('Acceder a la sesión') : (<>Sesión aún no disponible<br/>  (se abrirá 1 hora antes de la hora de la sesión)</>)}
                                                    </a>
                                                </li>
                                            );
            
                                        })}
                                    </ul>
                                )}
                            </li>
                        );
                    }
                })}
            </ul>
            <Link to="/" className="successLink">Volver al inicio</Link>
        </div>
    </div>
    
);
};


export default PagoExitoso; 